import * as TWEEN from "@tweenjs/tween.js"

const tList = []
requestAnimationFrame(function loop(time) {
    TWEEN.update(time)
    requestAnimationFrame(loop)
})

export const addAni = (tween) => {
    // tList.push(tween)
}
